import battery from './capability-tab/battery.svg';
import bridge from './capability-tab/bridge.svg';
import button from './capability-tab/button.svg';
import camera from './capability-tab/camera.svg';
import color from './capability-tab/color.svg';
import flows from './capability-tab/flows.svg';
import insights from './capability-tab/insights.svg';
import more from './capability-tab/more.svg';
import music from './capability-tab/music.svg';
import onOff from './capability-tab/on-off.svg';
import phase from './capability-tab/phase.svg';
import picker from './capability-tab/picker.svg';
import sensor from './capability-tab/sensor.svg';
import slider from './capability-tab/slider.svg';
import ternary from './capability-tab/ternary.svg';
import thermostat from './capability-tab/thermostat.svg';
import timeline from './capability-tab/timeline.svg';

export const capabilityTab = {
  battery,
  bridge,
  button,
  camera,
  color,
  flows,
  insights,
  more,
  music,
  onOff,
  phase,
  picker,
  sensor,
  slider,
  ternary,
  thermostat,
  timeline,
} as const;
